import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { Button } from '@/components/ui/Button'
import { PageToolbar } from '@/components/ui/page-toolbar'
import { FinanceSolicitacoesCatalog } from '@/components/Financeiro/solicitacoes/FinanceSolicitacoesCatalog'
import { FinanceRequestFormModal } from '@/components/Financeiro/solicitacoes/FinanceRequestFormModal'
import { useFinanceiroSolicitacoesPage } from '@/hooks/useFinanceiroSolicitacoesPage'
import { useAuthStore } from '@/stores/authStore'

export default function FinanceiroSolicitacoes() {
  const {
    allowedAreas,
    loading,
    typesByArea,
    selectedType,
    setSelectedType,
    submitting,
    submitRequest,
  } = useFinanceiroSolicitacoesPage()

  const selectedCard = selectedType
    ? [...typesByArea.values()].flat().find((t) => t.key === selectedType) ?? null
    : null

  const canSeeFila = ['admin', 'financeiro', 'manager'].includes(
    (useAuthStore.getState().user?.role ?? '').toLowerCase(),
  )

  return (
    <DashboardLayout title='Portal de solicitações'>
      <PageToolbar
        navigation={
          <p className='text-sm text-text-muted'>
            Escolha o tipo de solicitação. O financeiro receberá na aba Chamados do CRM.
          </p>
        }
        controls={
          canSeeFila ? (
            <Link to='/financeiro?tab=chamados'>
              <Button variant='secondary' size='sm' type='button'>
                <ArrowLeft size={14} />
                Voltar aos chamados
              </Button>
            </Link>
          ) : undefined
        }
      />

      {loading ? (
        <div className='glass-card flex justify-center py-16'>
          <div className='h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent' />
        </div>
      ) : (
        <FinanceSolicitacoesCatalog
          typesByArea={typesByArea}
          allowedAreas={allowedAreas}
          onSelect={setSelectedType}
        />
      )}

      {selectedCard && (
        <FinanceRequestFormModal
          type={selectedCard}
          open={Boolean(selectedType)}
          submitting={submitting}
          onClose={() => setSelectedType(null)}
          onSubmit={(formData, linkedEmpresaId, linkedDealId, attachments) => {
            if (!selectedType) return
            void submitRequest(selectedType, formData, linkedEmpresaId, linkedDealId, attachments)
          }}
        />
      )}
    </DashboardLayout>
  )
}
